export const globalActionDeviceDataMaps = {
  flood: {
    stage: {
      'data.[0].depth1': {
        name: 'Sensor Depth',
        unitName: 'Inches',
        units: 'Inches',
        type: 'float',
      },
      'data.[0].sensordepths': {
        name: 'Actual Depths',
        unitName: 'Inches',
        units: 'Inches',
        type: 'float',
      },
      'data.[0].depthDet1': {
        name: 'Depth Threshold 1',
        unitName: 'Inches',
        units: 'Inches',
        type: 'float',
      },
      'data.[0].depthDet2': {
        name: 'Depth Threshold 2',
        unitName: 'Inches',
        units: 'Inches',
        type: 'float',
      },
      'data.[0].depthDet3': {
        name: 'Depth Threshold 3',
        unitName: 'Inches',
        units: 'Inches',
        type: 'float',
      },
      'data.[0].airTemp': {
        name: 'Air Temperature',
        unitName: 'Â°C',
        units: 'Celsius',
        type: 'float',
      },
      'data.[0].baro': { name: 'Pressure', unitName: 'mBar', units: 'mBar', type: 'float' },
      'data.[0].battery': { name: 'Battery', unitName: 'Voltage', units: 'Voltage', type: 'float' },
      'data.[0].depthInd': {
        name: 'Depth Detection Indicator (Threshold Met)',
        units: 'flag',
        type: 'bool',
      },
      'data.[0].drInd': {
        name: 'Drop Rate Indicator (Threshold Met)',
        units: 'flag',
        type: 'bool',
      },
      'data.[0].dropSDI': {
        name: 'Device Drop Count (SDI-12) Tipping bucket',
        unitName: 'Drops',
        units: 'Drops',
        type: 'float',
      },
      'data.[0].soilSDI': {
        name: 'Soil Moisture Reading (SDI-12)',
        unitName: 'ADC (Analog to Digital Converter)',
        units: 'ADC',
        type: 'float',
      },
      'data.[0].soilTempSDI': {
        name: 'Soil Temperature Reading (SDI-12)',
        unitName: 'Â°C',
        units: 'Celsius',
        type: 'float',
      },
      'data.[0].ffi1': { name: 'Flash Flood Indicator', units: 'flag', type: 'bool' },
      'data.[0].h2oTemp': {
        name: 'Water Temperature',
        unitName: 'Â°C',
        units: 'Celsius',
        type: 'float',
      },
      'data.[0].rssi': { name: 'Signal Strength', unitName: 'dB', units: 'dB', type: 'float' },
    },
  },
  'rescalert devices': {
    'manual road closure': {
      'data.[0].status': {
        name: 'Device Status',
        type: 'int',
        units: 'flag',
        values: { 1: 'Closed', 0: 'Open' },
      },
    },
    'technology bridge_flashing lights': {
      'data.[0].status': {
        name: 'Device Status',
        type: 'int',
        units: 'flag',
        values: { 1: 'Closed', 0: 'Open', '-1': 'Maintenance Mode' },
      },
    },
    'technology bridge_siren/giant voice': {
      'data.[0].status': {
        name: 'Device Status',
        type: 'int',
        units: 'command',
        values: {
          0: 'Idle',
          1: 'Alerting',
          2: 'Tone/Message',
          3: 'Flood Siren Only',
          4: 'Flood Message ENG',
          5: 'Flood Message ESP',
          6: 'Test Tone',
          7: 'Cancel Audio',
          8: 'Modem Power Cycle',
          '-1': 'Maintenance Mode',
        },
      },
    },
    'buoy conditions': {
      'data.[0].air_temperature': {
        name: 'Air Temperature',
        type: 'float',
        units: ' °F',
        unitName: 'F',
      },
      'data.[0].dew_point': { name: 'Dew Point', type: 'float', units: ' °F', unitName: 'F' },
      'data.[0].wind_speed': { name: 'Wind Speed', type: 'float', units: 'MPH', unitName: 'MPH' },
      'data.[0].wind_gusts': { name: 'Wind Gusts', type: 'float', units: 'MPH', unitName: 'MPH' },
      'data.[0].wind_direction': { name: 'Wind Direction', type: 'string' },
      'data.[0].beaufort': {
        name: 'Beaufort',
        type: 'int',
        units: 'Beaufort Scale',
        unitName: 'Beaufort',
      },
      'data.[0].baro_pressure': {
        name: 'Barometric Pressure',
        type: 'float',
        units: 'inHg',
        unitName: 'inHg',
      },
      'data.[0].baro_tendency': { name: 'Barometric Tendency', type: 'int' },
      'data.[0].barometer': { name: 'Barometer', type: 'string' },
      'data.[0].visibility': { name: 'Visibility', type: 'float', units: 'mi', unitName: 'mi' },
      'data.[0].water_temperature': {
        name: 'Water Temperature',
        type: 'float',
        units: ' °F',
        unitName: 'F',
      },
      'data.[0].wave_height': { name: 'Wave Height', type: 'float', units: 'ft', unitName: 'ft' },
      'data.[0].wave_period': { name: 'Wave Period', type: 'float', units: 'sec', unitName: 'sec' },
    },
  },
  usgs: {
    'monitoring station': {},
  },
};
